import { Card, CardContent, Typography, Button, Box, Paper, Alert } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '../context/SessionContext';
import { contentApi } from '../utils/api';
import { DirectionsContent } from '../types';

export default function DirectionsPage() {
  const { updateStatus } = useSession();
  const { data: content } = useQuery<DirectionsContent>({
    queryKey: ['content', 'directions'],
    queryFn: () => contentApi.getDirections(),
  });

  const handleBegin = async () => {
    await updateStatus('assessment');
  };

  if (!content) {
    return (
      <Card>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography>Loading directions...</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          {content.title}
        </Typography>

        <Paper 
          variant="outlined" 
          sx={{ p: 3, my: 3 }}
          role="document"
          aria-label="Assessment directions"
        >
          <div dangerouslySetInnerHTML={{ __html: content.content }} />
        </Paper>

        {content.notes.map((note, index) => (
          <Alert key={index} severity="info" sx={{ mb: 2 }}>
            {note}
          </Alert>
        ))}

        <Box textAlign="center" sx={{ mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            onClick={handleBegin}
            endIcon={<PlayArrowIcon />}
            sx={{ px: 6, py: 1.5 }}
            aria-label="Begin the assessment"
          >
            Begin Assessment
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
